export interface TaskType {
  id: TASK_ID;
  names: Record<string, string>;
}

export enum TASK_ID {
  Schedule = 0,
  Command = 1,
  Condition = 2
}

export const TASK_TYPE_DATA: TaskType[] = [
  {
    id: TASK_ID.Schedule,
    names: {
      'en-US': 'Schedule',
      'ru-RU': 'Расписание',
      'ar-LB': 'الجدول الزمني',
      'uz-Latn-UZ': 'Jadval',
      'fr-FR': 'Planification'
    }
  },
  {
    id: TASK_ID.Command,
    names: {
      'en-US': 'Command',
      'ru-RU': 'Команда',
      'ar-LB': 'الأمر',
      'uz-Latn-UZ': 'Buyruq',
      'fr-FR': 'Commande'
    }
  },
  {
    id: TASK_ID.Condition,
    names: {
      'en-US': 'Condition',
      'ru-RU': 'Состояние',
      'ar-LB': 'الشرط',
      'uz-Latn-UZ': 'Vaziyat',
      'fr-FR': 'Condition'
    }
  }
];
